export const positions = [
  'top',
  'tl',
  'tr',
  'bottom',
  'bl',
  'br',
  'left',
  'lt',
  'lb',
  'right',
  'rt',
  'rb'
] as const

export type Position = (typeof positions)[number]

export type PopconfirmTypes = 'primary' | 'success' | 'warning' | 'strong' | 'danger'
